import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const MealTypes = [
  { key: 'B', label: 'Breakfast', basic: true, className: 'white' },
  { key: 'L', label: 'Lunch', basic: true, className: 'white' },
  { key: 'O', label: 'Other', basic: true, className: 'white' },
  { key: 'S', label: 'Supper', basic: true, className: 'white' },
];

const MealTypePicker = props => {
  const { onChange, active } = props;

  return (
    <div style={{ paddingBottom: '10px' }}>
      <Button.Group basic className="btn-group--active-group">
        {MealTypes.map(mealType => {
          const { label, ...others } = mealType;

          return (
            <Button
              {...others}
              active={active === mealType.key}
              onClick={e => {
                e.preventDefault();
                onChange(mealType.key);
              }}
            >
              {mealType.label}
            </Button>
          );
        })}
      </Button.Group>
    </div>
  );
};

MealTypePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  active: PropTypes.oneOf(MealTypes.map(m => m.key)),
};

export { MealTypePicker };



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/MealTypePicker.js